import React from 'react';
import styled from 'styled-components';
import PitchSidemenu from './PitchSidemenu';
import { RouteComponentProps } from 'react-router-dom';
import PitchVideoSettingsView from './PitchVideoSettingsView';

type TParams = { video: string; pitch: string };
interface Props extends RouteComponentProps<TParams> {}

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
`;

const Container1 = styled.div`
  height: 100%;
`;

const Container2 = styled.div`
  height: 100%;
  width: 100%;
  overflow: auto;
  display: inline-block;
`;

const PitchVideoSettings: React.FunctionComponent<Props> = (props) => {
  return (
    <Wrapper>
      <Container1>
        <PitchSidemenu />
      </Container1>
      <Container2 className="sciui-card sciui-m-l sciui-p-l sciui-bg-p-5">
        <PitchVideoSettingsView video={props.match.params.video} />
      </Container2>
    </Wrapper>
  );
};

export default PitchVideoSettings;
